import { addSupers, convertToSLSRectangle, requestSLSImageData } from '@fs/zion-sls'
import { buildLangUrl } from '@fs/zion-router'
import { getImagePermissions, getRecordPermissions } from '../../shared/services/platform/platformService'
import { errorCollector } from '../../shared/utils/utils'

export function getAttachedRects(displayHighlights) {
  const attachedHighlights = []

  if (displayHighlights)
    displayHighlights.ids.forEach((id) => {
      if (displayHighlights.highlights[id]?.attached)
        attachedHighlights.push(convertToSLSRectangle(displayHighlights.highlights[id]))
    })

  return attachedHighlights
}

export function goBackToGive(accessFromPrison, activityName = '') {
  const getInvolvedBase = accessFromPrison ? '/getinvolved/corrections' : '/getinvolved/opportunities'
  const path = activityName ? `${getInvolvedBase}?viewActivity=${activityName}` : getInvolvedBase

  const urlWithLang = buildLangUrl(path)

  window.location.assign(urlWithLang)
}

export const getImagePermission = async (taskList, fsUserAgentChain) => {
  let imageAuthorize = false
  try {
    let imagePermissions = false
    let slsData
    try {
      slsData = await requestSLSImageData({
        partitionKey: taskList[0].partitionKey,
        fsUserAgentChain,
        includeActions: false,
      })
    } catch (err) {
      if (err?.response?.status === 403) return false
      throw new Error(err)
    }
    addSupers(slsData.elements)
    const recordPermissions = await getRecordPermissions(slsData.elements, taskList[0]?.id)
    if (recordPermissions) {
      imagePermissions = await getImagePermissions(null, taskList[0].partitionKey)
      imageAuthorize = recordPermissions && imagePermissions
    }
  } catch (err) {
    errorCollector(err, taskList[0]?.partitionKey, {
      codeId: 666,
      status: err.response.status,
      responseBody: err.response.data,
    })
  }
  return imageAuthorize
}

export function noop() {}
